import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const formatProfesssionalAssoc = ({
	pa_name: name,
	pa_title: title,
	pa_time_period: timePeriod,
}) => {
	let professionalAssoc = name;

	if (title) {
		professionalAssoc += `, ${title}`;
	}

	if (timePeriod) {
		professionalAssoc += `, ${timePeriod}`;
	}

	return professionalAssoc;
};

const ProfessionalAssociation = (props) => {
	const professionalAssoc = props.data.professional_assoc;

	if (!_.isArray(professionalAssoc) || _.isEmpty(professionalAssoc)) {
		return null;
	}

	return (
		<ul className="bio-list">
			{_.map(professionalAssoc, association => (
				<li className="bio-list__item" key={_.uniqueId('list-item-')}>
					{formatProfesssionalAssoc(association)}
				</li>
			))}
		</ul>
	);
};

ProfessionalAssociation.propTypes = {
	data: PropTypes.object.isRequired,
};

export default ProfessionalAssociation;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/professional-association.js